
import Toast from 'vux/src/components/toast/index.vue'

import {rsaEncryFn} from "@/utils/commons";
export default {
components: { Toast },
name: "favorite",
data() {
return {
user: '',
msg: '',
showPositionValue: false,
oldPassword: '',
newPassword: '',
confirmPassword: '',
passwordShow: false,
languageShow: false,
languageList: {
1: '中文-中文',
0: '英文-English'
}
}
},
methods: {
passwordModule(){
this.passwordShow = true;
},
languageShowModule(){},
save(){
if(!this.oldPassword || this.oldPassword.length < 5) {
this.msg = '请入当前账户密码';
this.showPositionValue = true;
return;
}
if(!this.newPassword || this.newPassword !== this.confirmPassword) {
this.msg = '两次密码不一致';
this.showPositionValue = true;
return;
}
this.user['password'] = rsaEncryFn(this.oldPassword);
this.user['newPassword'] = rsaEncryFn(this.newPassword);
this.$put('api/user/pswUpdate', this.user).then(val => {
let msg = val;
if (msg.status == 201) {
this.msg = '旧密码错误！';
} else if (msg.status == 202) {
this.msg = '服务器繁忙，请稍后刷新重试！';
} else if (msg.status == 203) {
this.msg = '新密码不能少于5位数！';
} else {
this.msg = '操作成功';
this.newPassword = '';
this.confirmPassword = '';
this.oldPassword = '';
this.passwordShow = false
}
this.showPositionValue = true;
},err => {
this.msg(err.message);
this.showPositionValue = true;
})
},
backLastPage(){
if (this.$store.state.device === 'wap') {
this.$router.go(-1);
} else {
document.location = "http://action:10002/?";
}
},
passwordPage(){
this.passwordShow = false;
}
},
mounted() {
this.$get('api/person/current').then(val => {
this.user = val['user'];
})
},
}



// WEBPACK FOOTER //
// ./src/page/home/favorite.vue